"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobAdditionalItem = void 0;
const typeorm_1 = require("typeorm/browser");
const invoicing_target_1 = require("./invoicing-target");
const job_1 = require("./job");
const data_ui_1 = require("../data-ui");
const contact_profile_enum_1 = require("./contact-profile-enum");
const layouts_1 = require("../data-ui/layouts");
let JobAdditionalItem = class JobAdditionalItem {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
    }),
    __metadata("design:type", String)
], JobAdditionalItem.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Column)('text', {
        nullable: true,
    }),
    __metadata("design:type", String)
], JobAdditionalItem.prototype, "linkId", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.Column)('text'),
    __metadata("design:type", String)
], JobAdditionalItem.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision'),
    __metadata("design:type", Number)
], JobAdditionalItem.prototype, "quantity", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('Unit_measure'),
    (0, typeorm_1.Column)('text'),
    __metadata("design:type", String)
], JobAdditionalItem.prototype, "measure", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAdditionalItem.prototype, "pricePurchasingSum", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAdditionalItem.prototype, "priceSellingSum", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAdditionalItem.prototype, "priceListsSum", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAdditionalItem.prototype, "pricePurchasing", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAdditionalItem.prototype, "priceSelling", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAdditionalItem.prototype, "priceLists", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        nullable: false,
        enum: invoicing_target_1.GeneralInvoicingTargetEnum,
        name: 'invoicing_target',
    }),
    __metadata("design:type", String)
], JobAdditionalItem.prototype, "invoicingTarget", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], JobAdditionalItem.prototype, "createdAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], JobAdditionalItem.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.DeleteDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], JobAdditionalItem.prototype, "deletedAt", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => job_1.Job, (job) => job.additionalItems),
    (0, typeorm_1.JoinColumn)({ name: 'job_api_id', referencedColumnName: 'apiId' }),
    __metadata("design:type", job_1.Job)
], JobAdditionalItem.prototype, "job", void 0);
JobAdditionalItem = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Job Additional Item',
    }),
    (0, typeorm_1.Entity)('job_additional_items', { schema: 'public' })
], JobAdditionalItem);
exports.JobAdditionalItem = JobAdditionalItem;
//# sourceMappingURL=job-additional-items.js.map